import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { sanitizeUrl } from "@braintree/sanitize-url";
import queryString from "query-string";
import {
  getLocalStorageValue,
  removeAllStorageValues,
  removeLocalStorageValue
} from "../../utils/common";

const BackToButton = (props) => {
  const { t } = useTranslation();
  const [spEntityID, setSpEntityID] = useState("");
  const [RelayState, setRelayState] = useState("");
  const [goto, setGoto] = useState("");
  const [hideBackto, setHideBackto] = useState(false);

  useEffect(() => {
    if (getLocalStorageValue("backTo")) {
      const search = getLocalStorageValue("backTo");
      const params = queryString.parse(search);
      setSpEntityID(params.spEntityID);
      setRelayState(params.RelayState);
      setGoto(params.goto);
    } else {
      setHideBackto(true);
    }
  }, []);

  const backToSource = () => {
    if (spEntityID && RelayState) {
      removeAllStorageValues();
      if (getLocalStorageValue("backTo")) {
        removeLocalStorageValue("backTo");
      }
      const locationUrl = window.location.origin;
      let path;
      if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
        path = '/openam/idpssoinit?metaAlias=/BOSCitizens/devidp';
      } else {
        path = '/idpssoinit?metaAlias=/boscitizens/devidp';
      }
      const redirectUrl = locationUrl + path;
      const searchString = queryString.stringify(
        { spEntityID, RelayState },
        { sort: false }
      );
      window.location.href = sanitizeUrl(
        `${redirectUrl}&${decodeURIComponent(searchString)}`
      );
    } else if (goto) {
      removeAllStorageValues();
      if (getLocalStorageValue("backTo")) {
        removeLocalStorageValue("backTo");
      }
      const locationUrl = window.location.origin;
      let path='/ctidentity/login';
      const redirectUrl = locationUrl + path;
      const searchString = queryString.stringify(
        { goto },
        { sort: false }
      );
      window.location.href = sanitizeUrl(
        `${redirectUrl}?${decodeURIComponent(searchString)}`
      );
    }
  };

  return (
    <>
      {!hideBackto && (
        <div
          className="back-to-btn"
          role="button"
          tabIndex={0}
          onClick={() => backToSource()}
          onKeyPress={() => backToSource()}
        >
          {t("pages.profile.returnTo")}
        </div>
      )}
    </>
  );
};

export default BackToButton;
